import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { DOCK_FAB_SX } from '../../ui-components/FeedbackFAB';
import { useAssistant } from '../../contexts/AssistantContext';
import { useUserRole } from '../../contexts/UserRoleContext';

export default function AssistantFAB() {
  const { toggle } = useAssistant();
  const { permissions } = useUserRole();

  // Only render if user has ai_assistant view permission
  if (!permissions?.ai_assistant?.view) return null;

  return (
    <Tooltip title="Full Frame Assistent" placement="left">
      {/* Zelfde 'dock'-stijl als de feedback-knop (bottom 24): één rustige kolom rechtsonder. */}
      <Fab onClick={toggle} aria-label="Full Frame Assistent" sx={{ ...DOCK_FAB_SX, bottom: 82 }}>
        <AutoAwesomeIcon sx={{ fontSize: 21 }} />
      </Fab>
    </Tooltip>
  );
}
